import {
    REQUEST_TEMPORARY_USER,
    RECEIVE_TEMPORARY_USER,
    FAILURE_TEMPORARY_USER
} from './constants';
import { HTTP_METHOD_GET } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export function findTemporaryUserRequest(uuid) {
    return {
        [CALL_API]: {
            endpoint: '/user/temp/' + uuid,
            method: HTTP_METHOD_GET,
            types: [REQUEST_TEMPORARY_USER, RECEIVE_TEMPORARY_USER, FAILURE_TEMPORARY_USER]
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/tempuser/actions.js